/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MarqCommonProtocolFileResponse,
  MonitoringFilterProtocolPagingRequest,
  MonitoringFilterProtocolRequest,
  MonitoringFilterProtocolResponse,
  MonitoringPotentialAuthorizedProtocolsExcelExportBySellerIdsRequest,
  MonitoringPotentialAuthorizedProtocolsExcelExportRequest,
  MonitoringPotentialAuthorizedProtocolsExcelExportResponse,
  MonitoringPotentialAuthorizedProtocolsGetAllSellerIdsRequest,
  MonitoringPotentialAuthorizedProtocolsGetAllSellerIdsResponse,
  MonitoringPotentialAuthorizedProtocolsGetCountRequest,
  MonitoringPotentialAuthorizedProtocolsGetCountResponse,
  MonitoringPotentialAuthorizedProtocolsGetListingsRequest,
  MonitoringPotentialAuthorizedProtocolsGetListingsResponse,
  MonitoringPotentialAuthorizedProtocolsGetSellersRequest,
  MonitoringPotentialAuthorizedProtocolsGetSellersResponse,
  MonitoringPotentialAuthorizedProtocolsMarkAsAuthorizedRequest,
  MonitoringPotentialAuthorizedProtocolsMarkAsAuthorizedResponse,
  MonitoringPotentialAuthorizedProtocolsMarkAsDismissedRequest,
  MonitoringPotentialAuthorizedProtocolsMarkAsDismissedResponse,
  MonitoringPotentialAuthorizedProtocolsMarkAsUnauthorizedRequest,
  MonitoringPotentialAuthorizedProtocolsMarkAsUnauthorizedResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class MonitoringReviewNeeded<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags MonitoringReviewNeeded
   * @name ReviewNeededPotentialAuthorizedCountCreate
   * @request POST:/monitoring/review-needed/potential-authorized/count
   */
  reviewNeededPotentialAuthorizedCountCreate = (
    data: MonitoringPotentialAuthorizedProtocolsGetCountRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPotentialAuthorizedProtocolsGetCountResponse, any>({
      path: `/monitoring/review-needed/potential-authorized/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringReviewNeeded
   * @name ReviewNeededPotentialAuthorizedSellersCreate
   * @request POST:/monitoring/review-needed/potential-authorized/sellers
   */
  reviewNeededPotentialAuthorizedSellersCreate = (
    data: MonitoringPotentialAuthorizedProtocolsGetSellersRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPotentialAuthorizedProtocolsGetSellersResponse, any>({
      path: `/monitoring/review-needed/potential-authorized/sellers`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringReviewNeeded
   * @name ReviewNeededPotentialAuthorizedListingsCreate
   * @request POST:/monitoring/review-needed/potential-authorized/listings
   */
  reviewNeededPotentialAuthorizedListingsCreate = (
    data: MonitoringPotentialAuthorizedProtocolsGetListingsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPotentialAuthorizedProtocolsGetListingsResponse, any>({
      path: `/monitoring/review-needed/potential-authorized/listings`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringReviewNeeded
   * @name ReviewNeededPotentialAuthorizedAllSellerIdsCreate
   * @request POST:/monitoring/review-needed/potential-authorized/all-seller-ids
   */
  reviewNeededPotentialAuthorizedAllSellerIdsCreate = (
    data: MonitoringPotentialAuthorizedProtocolsGetAllSellerIdsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPotentialAuthorizedProtocolsGetAllSellerIdsResponse, any>({
      path: `/monitoring/review-needed/potential-authorized/all-seller-ids`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringReviewNeeded
   * @name ReviewNeededPotentialAuthorizedMarkAsAuthorizedCreate
   * @request POST:/monitoring/review-needed/potential-authorized/mark-as-authorized
   */
  reviewNeededPotentialAuthorizedMarkAsAuthorizedCreate = (
    data: MonitoringPotentialAuthorizedProtocolsMarkAsAuthorizedRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPotentialAuthorizedProtocolsMarkAsAuthorizedResponse, any>({
      path: `/monitoring/review-needed/potential-authorized/mark-as-authorized`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringReviewNeeded
   * @name ReviewNeededPotentialAuthorizedMarkAsUnauthorizedCreate
   * @request POST:/monitoring/review-needed/potential-authorized/mark-as-unauthorized
   */
  reviewNeededPotentialAuthorizedMarkAsUnauthorizedCreate = (
    data: MonitoringPotentialAuthorizedProtocolsMarkAsUnauthorizedRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPotentialAuthorizedProtocolsMarkAsUnauthorizedResponse, any>({
      path: `/monitoring/review-needed/potential-authorized/mark-as-unauthorized`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringReviewNeeded
   * @name ReviewNeededPotentialAuthorizedMarkAsDismissedCreate
   * @request POST:/monitoring/review-needed/potential-authorized/mark-as-dismissed
   */
  reviewNeededPotentialAuthorizedMarkAsDismissedCreate = (
    data: MonitoringPotentialAuthorizedProtocolsMarkAsDismissedRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPotentialAuthorizedProtocolsMarkAsDismissedResponse, any>({
      path: `/monitoring/review-needed/potential-authorized/mark-as-dismissed`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringReviewNeeded
   * @name ReviewNeededPotentialAuthorizedExcelExportCreate
   * @request POST:/monitoring/review-needed/potential-authorized/excel/export
   */
  reviewNeededPotentialAuthorizedExcelExportCreate = (
    data: MonitoringPotentialAuthorizedProtocolsExcelExportRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringPotentialAuthorizedProtocolsExcelExportResponse, any>({
      path: `/monitoring/review-needed/potential-authorized/excel/export`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringReviewNeeded
   * @name ReviewNeededPotentialAuthorizedExcelExportSellerIdCreate
   * @request POST:/monitoring/review-needed/potential-authorized/excel/export/seller-id
   */
  reviewNeededPotentialAuthorizedExcelExportSellerIdCreate = (
    data: MonitoringPotentialAuthorizedProtocolsExcelExportBySellerIdsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/monitoring/review-needed/potential-authorized/excel/export/seller-id`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringReviewNeeded
   * @name ReviewNeededPotentialAuthorizedGetAllCustomTagsCreate
   * @request POST:/monitoring/review-needed/potential-authorized/get-all-custom-tags
   */
  reviewNeededPotentialAuthorizedGetAllCustomTagsCreate = (
    data: MonitoringFilterProtocolRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/monitoring/review-needed/potential-authorized/get-all-custom-tags`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringReviewNeeded
   * @name ReviewNeededPotentialAuthorizedGetAllDomainsCreate
   * @request POST:/monitoring/review-needed/potential-authorized/get-all-domains
   */
  reviewNeededPotentialAuthorizedGetAllDomainsCreate = (
    data: MonitoringFilterProtocolRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/monitoring/review-needed/potential-authorized/get-all-domains`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringReviewNeeded
   * @name ReviewNeededPotentialAuthorizedGetAllSellersCreate
   * @request POST:/monitoring/review-needed/potential-authorized/get-all-sellers
   */
  reviewNeededPotentialAuthorizedGetAllSellersCreate = (
    data: MonitoringFilterProtocolPagingRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/monitoring/review-needed/potential-authorized/get-all-sellers`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringReviewNeeded
   * @name ReviewNeededPotentialAuthorizedGetAllPotentialAuthorizedReasonsCreate
   * @request POST:/monitoring/review-needed/potential-authorized/get-all-potential-authorized-reasons
   */
  reviewNeededPotentialAuthorizedGetAllPotentialAuthorizedReasonsCreate = (
    data: MonitoringFilterProtocolRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/monitoring/review-needed/potential-authorized/get-all-potential-authorized-reasons`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
